export const RANK_NAMES = [
  'None',
  'Zenova Achiever',
  'Zenova Champion',
  'Zenova Elite',
  'Zenova Titan',
  'Zenova Icon'
];
export const RANK_COLORS = ['#666', '#c0c0c0', '#ffd700', '#e5e4e2', '#b9f2ff', '#ff2d92'];

export const INV_TYPES = ['Real', 'Virtual', 'Leader'];

export const ACTIVITY_TYPES = {
  1: 'Investment',
  2: 'ROI',
  3: 'Level Income',
  4: 'Rank Pool',
  5: 'Claim',
  6: 'Withdraw Level',
  7: 'Rank Promoted'
};

export const ACTIVITY_ICONS = {
  1: '💰',
  2: '📈',
  3: '🔗',
  4: '🏆',
  5: '💎',
  6: '💸',
  7: '⭐'
};

export const PACKAGE_NAMES = [
  'Starter',
  'Basic',
  'Bronze',
  'Silver',
  'Gold',
  'Platinum',
  'Diamond',
  'Elite',
  'Royal',
  'Crown',
  'Cosmic'
];

export const NUM_PACKAGES = 11;
export const NUM_LEVELS = 10;
export const NUM_RANKS = 5;
export const NUM_MILESTONES = 10;
